import type { CustomInsightsApiRequestOptions } from "@tracify/shared";

function parseStoredToken(rawToken: string | null): string | null {
  if (!rawToken) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawToken);
    if (typeof parsed === "string" && parsed.trim().length > 0) {
      return parsed;
    }
  } catch {
    // Token may already be a plain string.
  }

  return rawToken.trim().length > 0 ? rawToken : null;
}

export function getCustomInsightsApiRequestOptions(
  organisationId: string
): CustomInsightsApiRequestOptions {
  const baseUrl = process.env.NEXT_PUBLIC_TRACIFY_API_BASE_URL;
  if (!baseUrl) {
    throw new Error("Missing NEXT_PUBLIC_TRACIFY_API_BASE_URL");
  }
  const normalizedOrganisationId = organisationId.trim();
  if (!normalizedOrganisationId) {
    throw new Error("Organisation ID is required");
  }

  const token =
    typeof window === "undefined"
      ? null
      : parseStoredToken(window.localStorage.getItem("token"));

  return {
    baseUrl,
    organisationId: normalizedOrganisationId,
    token,
  };
}
